import { render, staticRenderFns } from "./NewMessageChatSummary.vue?vue&type=template&id=6532a514&scoped=true"
import script from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewMessageChatSummary.vue?vue&type=style&index=0&id=6532a514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6532a514",
  null
  
)

export default component.exports